module.exports = __webpack_public_path__ + "img/vertical_3_4_7042.0aa09155.png";